export const AUTH_TOKEN_KEY = 'AUTH_TOKEN_KEY';

// The app is served from both *.ru and .com hosts. On a *.ru host the admin must use the *.ru API
// (Bank131 region); everyone else uses the default API. Resolved at runtime from the hostname so a
// single build serves both. Falls back to the default API when no *.ru API is configured, keeping
// non-.ru deployments unaffected. Mirrors the same split in the account app.
export const IS_RU_DOMAIN = typeof window !== 'undefined' && window.location.hostname.endsWith('.ru');
export const API_URL = (IS_RU_DOMAIN && process.env.REACT_APP_API_URL_RU) || process.env.REACT_APP_API_URL;

// For testing only: set REACT_APP_FAKE_AUTH_TOKEN in .env to bypass Firebase auth.
// Leave unset or empty to use normal Firebase auth.
export const FAKE_AUTH_TOKEN = process.env.REACT_APP_FAKE_AUTH_TOKEN ?? '';

export const ENDPOINTS = {
    wallet: '/api/admin/wallet/summary',
    transactions: '/api/admin/wallet/transactions',
    myProfile: '/api/profiles/my-profile',
    userAvatar: '/api/profiles/avatar',
    getUser: '/api/admin/user-profiles',
    getUserRecentGames: '/api/admin/user-profiles/:userId/recent-games',
    withdrawRequests: '/api/admin/withdrawals',
    withdrawRequest: '/api/admin/withdrawals',
    paypalCreateOrder: '/api/wallet/pay-pal/create-order',
    withdrawCreateOrder: '/api/wallet/withdraw/create-order',
    withdrawSetPaymentAccountVerified: '/api/admin/withdrawals/set-payment-account-verified',
    setPaymentRequestStatus: '/api/admin/withdrawals/set-payment-request-status',
    getChallenges: '/api/tester/get-challenges',
    getActions: '/api/tester/get-actions',
    applyAction: '/api/tester/apply-action',
    exportToExcel: '/api/admin/withdrawals/export-to-excel',
    tournaments: '/api/tournaments',
    tournament: '/api/admin-tournaments',
    adminTournaments: '/api/admin-tournaments',
    availableGames: '/api/games/v2/available',
};

export const CURRENCY = '€';
export const MONTH_FORMAT = 'd MMMM';
export const TIME_FORMAT = 'HH:mm';
export const MAX_TOPUP = '100';
export const DATE_FORMAT = 'dd.MM.yyyy HH:mm';

interface IQueryKeysProps {
    availablePlayers: string;
    myProfile: string;
    myWallet: string;
    sendChallenge: string;
    publishChallenge: string;
    cancelChallenge: string;
    getActiveChallenges: string;
    getChallenge: string;
    getChallengesPublished: string;
    startChallenge: string;
    acceptChallenge: string;
    closeChallenge: string;
    getGamesList: string;
    getFavoriteGames: string;
    getQuickFilters: string;
    getQuickChallenge: string;
    getLeaderBoard: string;
    postQuickChallenge: string;
    getTransactions: string;
    setPaymentAccountVerified: string;
    applyAction: string;
    setPaymentRequestStatus: string;
    withdrawRequests: string;
    getUser: string;
    getUserRecentGames: string;
    getWithdrawRequest: string;
    availableGames: string;
    tournamentsList: string;
    tournament: string;
    deleteTournament: string;
    updateTournament: string;
    updateTournamentChallenge: string;
}

export const QueryKeys: IQueryKeysProps = {
    availablePlayers: 'availablePlayers',
    myProfile: 'myProfile',
    myWallet: 'myWallet',
    sendChallenge: 'sendChallenge',
    publishChallenge: 'publishChallenge',
    cancelChallenge: 'cancelChallenge',
    getActiveChallenges: 'getActiveChallenges',
    getChallenge: 'getChallenge',
    getChallengesPublished: 'getChallengesPublished',
    startChallenge: 'startChallenge',
    acceptChallenge: 'acceptChallenge',
    closeChallenge: 'closeChallenge',
    getGamesList: 'getGamesList',
    getFavoriteGames: 'getFavoriteGames',
    getQuickFilters: 'getQuickFilters',
    getQuickChallenge: 'getQuickChallenge',
    getLeaderBoard: 'getLeaderBoard',
    postQuickChallenge: 'postQuickChallenge',
    getTransactions: 'getTransactions',
    setPaymentAccountVerified: 'setPaymentAccountVerified',
    applyAction: 'applyAction',
    setPaymentRequestStatus: 'setPaymentRequestStatus',
    withdrawRequests: 'withdrawRequests',
    getUser: 'getUser',
    getUserRecentGames: 'getUserRecentGames',
    getWithdrawRequest: 'getWithdrawRequest',
    availableGames: 'availableGames',
    tournamentsList: 'tournamentsList',
    tournament: 'tournament',
    deleteTournament: 'deleteTournament',
    updateTournament: 'updateTournament',
    updateTournamentChallenge: 'updateTournamentChallenge',
};

export const PAGE_OPTIONS = [15, 30, 60, 100, 1000];
